
// const BASE_URL = "https://localhost:7231/api/PTSlab";


import { BASE_URL } from "../config";

export const getAllPTHeaders = async () => {
  try {
    const response = await fetch(`${BASE_URL}/PTSlab`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch PT Headers");
    }

    return await response.json(); // Returns array of headers with slabDetails
  } catch (error) {
    console.error("Error fetching PT Headers:", error);
    throw error;
  }
};


export const updatePTHeaderWithSlabs = async (header) => {
  try {
    const response = await fetch(`${BASE_URL}/PTSlab/ptslab/${header.ptid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(header),
    });

    if (!response.ok) {
      throw new Error(`Failed to update PT Header. Status: ${response.status}`);
    }

    // If 200 OK, parse response or return success
    return await response.json(); // or return true if API returns nothing
  } catch (error) {
    console.error("Error updating PT Header with slabs:", error);
    throw error;
  }
};

export const addPTHeader = async (header) => {
  try {
    const crUser = sessionStorage.getItem("username") || "guest";
    const crDate = new Date().toISOString();
    const response = await fetch(`${BASE_URL}/PTSlab/ptslab`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...header,
        crUser: crUser,
        crDate: crDate,
        deleted: "N",
        slabDetails: (header.slabDetails || []).map(s => ({
          ...s,
          crUser: crUser,
          crDate: crDate,
          deleted: "N",
        }))
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to add PT Header. Status: ${response.status}`);
    }

    return await response.json(); // Returns the created PT Header with ptid
  } catch (error) {
    console.error("Error adding PT Header:", error);
    throw error;
  }
};

export const deletePTHeader = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/PTSlab/ptslab/${id}`, {
      method: "DELETE",
    });

    if (response.status === 204) {
      return true;
    } else {
      throw new Error("Failed to delete deduction");
    }
  } catch (error) {
    console.error("Error deleting deduction:", error);
    throw error;
  }
};